import script from "./FIXTokenHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./FIXTokenHeader.vue?vue&type=script&setup=true&lang=js"

import "./FIXTokenHeader.vue?vue&type=style&index=0&id=4ae78011&scoped=true&lang=css"

import exportComponent from "/var/www/profixone-instant-clone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ae78011"]])

export default __exports__